import React, { useState } from 'react'
import Drawer from 'components/Drawer'
import Button from 'components/Button'

// Sample groupList for testing:
// const groupList = [
//   { id: '1', name: 'Alpha Group', collegeCount: 5 },
//   { id: '2', name: 'Beta Group', collegeCount: 12 },
//   { id: '3', name: 'Gamma Group', collegeCount: 8 },
//   { id: '4', name: 'Delta Group', collegeCount: 3 },
// ];

const AddToGroupDrawer = ({
  open,
  onClose,
  mode,
  setMode,
  groupList = [],
  selectedGroup,
  setSelectedGroup,
  onSave,
  showRemoveInstitutePopup,
  onGroupSelect,
  fetchGroupList,
}) => {
  const [search, setSearch] = useState('')
  const [openAccordion, setOpenAccordion] = useState(true)

  const footer = () => {
    // Disable save button when mode is 'existing' and no group is selected
    const isSaveDisabled = mode === 'existing' && !selectedGroup

    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
        <Button.Secondary text="Cancel" onClick={onClose} />
        <Button.Primary
          text="Save"
          disabled={isSaveDisabled}
          onClick={() => {
            if (onSave) onSave({ isRemove: false, group: selectedGroup })
          }}
        />
      </div>
    )
  }
  const content = () => {
    return (
      <>
        <div style={{ display: 'flex', gap: 24, marginBottom: 32 }}>
          <button
            style={{
              width: 250,
              height: 69,
              border:
                mode === 'new' ? '2px solid #3249D7' : '1px solid #E0E0E0',
              borderRadius: 15,
              padding: '10px 20px',
              fontWeight: 600,
              fontSize: 14,
              background: mode === 'new' ? '#F7F8FF' : '#fff',
              color: '#181A1F',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              minWidth: 220,
            }}
            onClick={() => setMode('new')}
          >
            <span style={{ display: 'inline-block', marginRight: 12 }}>
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9.5" r="8.5" stroke="#3249D7" fill="#fff" />
                {mode === 'new' && (
                  <circle
                    cx="8.99888"
                    cy="9.49888"
                    r="6.42857"
                    fill="#3249D7"
                  />
                )}
              </svg>
            </span>
            Create a new Group
          </button>
          <button
            style={{
              width: 250,
              height: 69,
              border:
                mode === 'existing' ? '2px solid #3249D7' : '1px solid #E0E0E0',
              borderRadius: 15,
              padding: '10px 20px',
              fontWeight: 600,
              fontSize: 14,
              background: mode === 'existing' ? '#F7F8FF' : '#fff',
              color: '#181A1F',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              minWidth: 220,
            }}
            onClick={() => setMode('existing')}
          >
            <span style={{ display: 'inline-block', marginRight: 12 }}>
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9.5" r="8.5" stroke="#3249D7" fill="#fff" />
                {mode === 'existing' && (
                  <circle
                    cx="8.99888"
                    cy="9.49888"
                    r="6.42857"
                    fill="#3249D7"
                  />
                )}
              </svg>
            </span>
            Add to Existing Group
          </button>
        </div>
        {mode === 'existing' && (
          <>
            <div
              style={{
                position: 'relative',
                marginBottom: 12,
              }}
            >
              <input
                style={{
                  width: '100%',
                  padding: '12px 40px 12px 16px',
                  borderRadius: 10,
                  border: '1px solid #E0E0E0',
                  fontSize: 16,
                  cursor: 'text',
                  outline: 'none',
                }}
                placeholder="Search group"
                value={search}
                onChange={e => {
                  setSearch(e?.target?.value)
                  fetchGroupList(e?.target?.value)
                }}
                readOnly={false}
              />
              <span
                style={{
                  position: 'absolute',
                  right: 8,
                  top: '50%',
                  width: 32,
                  height: 32,
                  transform: 'translateY(-50%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  pointerEvents: 'auto',
                }}
                onClick={() => setOpenAccordion(v => !v)}
              >
                <svg
                  width="18"
                  height="10"
                  viewBox="0 0 8 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.29635 4.3L0.69635 1.7C0.379683 1.38333 0.309017 1.021 0.48435 0.613C0.659017 0.204333 0.97135 0 1.42135 0H6.57135C7.02135 0 7.33368 0.204333 7.50835 0.613C7.68368 1.021 7.61302 1.38333 7.29635 1.7L4.69635 4.3C4.59635 4.4 4.48802 4.475 4.37135 4.525C4.25468 4.575 4.12968 4.6 3.99635 4.6C3.86302 4.6 3.73802 4.575 3.62135 4.525C3.50468 4.475 3.39635 4.4 3.29635 4.3Z"
                    fill="#CCCFD6"
                  />
                </svg>
              </span>
            </div>
            {openAccordion && (
              <div
                style={{
                  border: '1px solid #E0E0E0',
                  borderRadius: 12,
                  background: '#fff',
                  padding: 0,
                  maxHeight: '100vh',
                  overflowY: 'auto',
                }}
              >
                {groupList.length === 0 && (
                  <div style={{ padding: '16px 24px', color: '#888' }}>
                    No groups found
                  </div>
                )}
                {groupList.map(group => (
                  <div
                    key={group.id || group.name}
                    style={{
                      padding: '16px 24px',
                      cursor: 'pointer',
                      background:
                        selectedGroup?.id === group.id ? '#F7F8FF' : '#fff',
                      fontWeight: selectedGroup?.id === group.id ? 700 : 500,
                      color: '#3249D7',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                    onClick={() => {
                      setSelectedGroup(group)
                      if (onGroupSelect) onGroupSelect(group)
                    }}
                  >
                    <span>{group.groupName}</span>
                    <span style={{ color: '#181A1F', fontWeight: 500 }}>
                      <span style={{ fontWeight: 700 }}>
                        {group.collegeCount}
                      </span>{' '}
                      Colleges
                    </span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </>
    )
  }
  return (
    <Drawer
      zIndex={3000}
      visible={open}
      onClose={onClose}
      title="Add to group"
      width={600}
      footer={footer()}
      content={content()}
    />
  )
}

export default AddToGroupDrawer
